import { render } from "./IconItemCategoryTravel.vue?vue&type=template&id=410ea02f"
import script from "./IconItemCategoryTravel.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryTravel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__